import { Link } from "react-router-dom";

const heroStats = [
  { value: "128+", label: "已更新话数" },
  { value: "40+", label: "深度解析文章" },
  { value: "2.3k+", label: "读者热议" },
  { value: "9.1", label: "读者平均评分" },
];

function Hero() {
  return (
    <section className="relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center object-top"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Stylized%20editorial%20manga%20collage%20illustration%20in%20warm%20vermilion%20and%20cream%20ink%20palette%2C%20overlapping%20vintage%20comic%20panels%20with%20halftone%20dots%20speech%20bubbles%20and%20brush%20textures%2C%20cozy%20slice-of-life%20narrative%20atmosphere%2C%20abstract%20artistic%20composition%2C%20no%20readable%20text%2C%20high%20detail&width=1600&height=900&seq=hero-manga&orientation=landscape')",
        }}
        aria-hidden="true"
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/55"></div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col items-center px-4 py-24 text-center md:py-32">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-black/25 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur-sm md:text-sm">
          <i className="ri-quill-pen-line text-primary-200"></i>
          嘿咻嘿咻漫画 · 追更指南
        </span>
        <h1 className="mt-6 max-w-3xl font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
          理清剧情脉络
          <span className="text-accent-300">，</span>
          读懂每格温柔
        </h1>
        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
          剧情速览、结局考据、角色档案与读者讨论一网打尽，帮你快速理清嘿咻嘿咻漫画的故事脉络，角色设定与读者评价尽在掌握，追更不迷路。
        </p>
        <div className="mt-8 flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/plot"
            className="w-full whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-400 sm:w-auto"
          >
            进入剧情解析
          </Link>
          <Link
            to="/characters"
            className="w-full whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20 sm:w-auto"
          >
            浏览角色档案
          </Link>
        </div>

        <dl className="mt-14 grid w-full max-w-4xl grid-cols-2 gap-4 sm:grid-cols-4">
          {heroStats.map((s) => (
            <div
              key={s.label}
              className="rounded-lg border border-background-50/15 bg-black/20 px-4 py-4 backdrop-blur-sm"
            >
              <dt className="order-2 mt-1 block text-xs text-background-200/90">
                {s.label}
              </dt>
              <dd className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
                {s.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}

export default Hero;